import * as ViewModel from '@/core/presenter/viewModel';
import clsx from 'clsx';
import SendTransactionInfo from './SendTransactionInfo';
import SendTransactionAmountInfo from './SendTransactionAmountInfo';

interface IProps {
  trxAddress: string;
  sendAddress: string;
  curculateKrw: string;
  sendAsset: string;
  selectedAsset?: ViewModel.IAsset;
  trxBalance: string;
  fee?: number;
  isFeeNotice: boolean;
  isCancelModalOpen: boolean;
  isSendCompleteModalOpen: boolean;
  isFeeNoticeModalOpen: boolean;
  onClickSendCheckNextBtn: () => void;
  onClickSendCancelBtn: () => void;
  onClickCancelModalClose: () => void;
  onClickCancelModalYes: () => void;
  onClickSendCompleteModalConfirm: () => void;
  onClickFeeNoticeModalClose: () => void;
}

const SendCheckViewContent = ({
  trxAddress,
  sendAddress,
  curculateKrw,
  sendAsset,
  selectedAsset,
  trxBalance,
  fee,
  isCancelModalOpen,
  isSendCompleteModalOpen,
  isFeeNoticeModalOpen,
  onClickSendCheckNextBtn,
  onClickSendCancelBtn,
  onClickCancelModalClose,
  onClickCancelModalYes,
  onClickSendCompleteModalConfirm,
  onClickFeeNoticeModalClose,
}: IProps) => {
  return (
    <>
      <div className="send-confirm-card">
        <SendTransactionInfo trxAddress={trxAddress} sendAddress={sendAddress} />
        <SendTransactionAmountInfo
          sendAsset={sendAsset}
          curculateKrw={curculateKrw}
          selectedAsset={selectedAsset}
          trxBalance={trxBalance}
          fee={fee}
        />
      </div>
      <div className="send-action-buttons">
        <button
          type="button"
          className="send-cancel-btn text-base font-semibold"
          onClick={onClickSendCancelBtn}
        >
          취소
        </button>
        <button
          type="button"
          className="send-next-btn active text-base font-semibold"
          onClick={onClickSendCheckNextBtn}
        >
          확인
        </button>
      </div>

      {/* 취소 확인 모달 */}
      <div className={clsx('modal-overlay', !isCancelModalOpen && 'hidden')} id="cancelConfirmModal">
        <div className="modal-content modal-small">
          <button type="button" className="modal-close" onClick={onClickCancelModalClose}>
            <img src="./images/close-icon.png" alt="닫기" className="close-icon" />
          </button>

          <div className="modal-body">
            <h2 className="modal-confirm-title text-base font-bold">취소하시겠습니까?</h2>

            <div className="modal-confirm-buttons">
              <button
                type="button"
                className="modal-confirm-no text-lg font-semibold"
                onClick={onClickCancelModalClose}
              >
                아니오
              </button>
              <button
                type="button"
                className="modal-confirm-yes text-lg font-semibold"
                onClick={onClickCancelModalYes}
              >
                예
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* 전송 완료 모달 */}
      <div className={clsx('modal-overlay', !isSendCompleteModalOpen && 'hidden')} id="sendCompleteModal">
        <div className="modal-content modal-medium">
          <button type="button" className="modal-close" onClick={onClickSendCompleteModalConfirm}>
            <img src="./images/close-icon.png" alt="닫기" className="modal-close-icon" />
          </button>

          <div className="modal-body">
            <div className="modal-icon-warning">
              <img src="./images/success-icon.png" alt="성공" className="modal-icon" />
            </div>

            <h2 className="modal-warning-title text-lg font-bold">전송 요청이 성공되었습니다.</h2>

            <button
              type="button"
              className="modal-button text-lg font-semibold"
              onClick={onClickSendCompleteModalConfirm}
            >
              확인
            </button>
          </div>
        </div>
      </div>

      {/* 수수료 부족 모달 */}
      <div className={clsx('modal-overlay', !isFeeNoticeModalOpen && 'hidden')} id="feeNoticeModal">
        <div className="modal-content modal-medium">
          <button type="button" className="modal-close" onClick={onClickFeeNoticeModalClose}>
            <img src="./images/close-icon.png" alt="닫기" className="modal-close-icon" />
          </button>

          <div className="modal-body">
            <div className="modal-icon-warning">
              <img src="./images/alert-icon.png" alt="경고" className="modal-icon" />
            </div>

            <h2 className="modal-warning-title text-lg font-bold">
              전송 수수료인 솔라나(SOL)가 부족합니다.
              <br />
              솔라나 잔액을 확인해주세요!
            </h2>

            <button
              type="button"
              className="modal-button text-lg font-semibold"
              onClick={onClickFeeNoticeModalClose}
            >
              확인
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default SendCheckViewContent;
